import { c as _c } from "react/compiler-runtime";
import React from 'react';
import styled, { css } from 'styled-components';
import { Flex, Flex3XS, Flex4XS, FlexCol, makeCentered } from '@/components/Flex';
import Typography from '@/components/core/Typography/Typography';
import { FlexCenter } from '@/components/Helpers';
import { Link } from '@/components/Link';
import { useTranslations } from 'next-intl';
import { device, HideAbove, HideBelow } from '@/components/Media';
import Logo from '@/components/Logo/Logo';
export const AuthPageContainer = styled(FlexCol)`
    align-self: start;
    justify-content: space-between;
    min-height: 484px;

    @media screen and ${device.laptopS} {
        align-self: center;
    }
`;
export const PageTitle = styled(Typography).attrs({
  variant: 'uiType',
  size: '3xl',
  modifier: 'S'
})`
    text-align: center;
    display: block;
    color: ${props => props.theme.colors.palette.grey_800};

    @media screen and ${device.laptopS} {
        font-size: ${({
  theme
}) => theme.typography.uiType['xl'].S.size};
        line-height: ${({
  theme
}) => theme.typography.uiType['xl'].S.lineHeight};
        letter-spacing: ${({
  theme
}) => theme.typography.uiType['xl'].S.letterSpacing};
    }
`;
export const FormContainer = styled(FlexCol)`
    margin-top: 54px;
    margin-left: auto;
    margin-right: auto;
    align-items: center;
    gap: ${({
  theme
}) => theme.spacing.md};

    @media ${device.laptopS} {
        margin-top: ${({
  theme
}) => theme.spacing['3xs']};
        gap: ${({
  theme
}) => theme.spacing['2xs']};
    }
`;
export const MainContent = styled(FlexCol)`
    flex-grow: 1;

    @media ${device.laptopS} {
        gap: ${({
  theme
}) => theme.spacing['2xs']};
        justify-content: center;
    }
`;
export const CenteredFlex3XS = makeCentered(Flex3XS, {
  x: true
});
export const CenteredFlex4XS = styled(makeCentered(Flex4XS, {
  x: true,
  y: true
}))`
    
`;
const NeedHelpBlockWrapper = styled(CenteredFlex4XS)<{
  withDivider: boolean;
}>`
    ${({
  withDivider
}) => withDivider && css`
        @media screen and ${device.laptopS} {
            border-top: 1px solid ${({
  theme
}) => theme.colors.palette.grey_450};
        }
    `};
`;
export const GreyTypography = styled(Typography)`
    color: ${({
  theme
}) => theme.colors.palette.grey_700};
    white-space: pre;

    @media screen and ${device.laptopS} {
        white-space: unset;
        font-size: ${({
  theme
}) => theme.typography.uiType['sm'].S.size};
        line-height: 21px;
        letter-spacing: ${({
  theme
}) => theme.typography.uiType['sm'].S.letterSpacing};
    }
`;
export const FlexFitCenter = styled(FlexCenter)`
    height: 100%;
    flex-grow: 1;

    @media screen and ${device.laptopS} {
        flex-grow: 0;
    }
`;
const GreyTypographyWithCircle = styled(GreyTypography)`
    position: relative;

    &::after {
        content: '';
        background-color: #fff;
        border-radius: 2046px;
        height: 2046px;
        width: 2046px;
        position: absolute;
        left: -961px;
        bottom: -10px;
        z-index: -999;
    }
`;
const MoonOneLogoWrapper = styled(Flex)`
    justify-content: center;
`;
export const NeedHelpBlock = t0 => {
  const $ = _c(17);
  const {
    withDivider: t1
  } = t0;
  const withDivider = t1 === undefined ? true : t1;
  const t = useTranslations();
  let t2;
  if ($[0] !== t) {
    t2 = t("auth.needHelp");
    $[0] = t;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t2) {
    t3 = <HideBelow md={true}><GreyTypographyWithCircle variant="uiType" size="sm" modifier="R" data-testid="need-help-text">{t2}</GreyTypographyWithCircle></HideBelow>;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t) {
    t4 = t("auth.needHelp");
    $[4] = t;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t4) {
    t5 = <HideAbove md={true}><GreyTypography variant="uiType" size="sm" modifier="R" data-testid="need-help-text">{t4}</GreyTypography></HideAbove>;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t) {
    t6 = t("auth.contactUs");
    $[8] = t;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t6) {
    t7 = <Link href="https://t.me/moondmc_bot" target="_blank" variant="uiType" size="sm" modifier="S" data-testid="contact-us-link">{t6}</Link>;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t3 || $[13] !== t5 || $[14] !== t7 || $[15] !== withDivider) {
    t8 = <CenteredFlex4XS><NeedHelpBlockWrapper withDivider={withDivider}>{t3}{t5} {t7}</NeedHelpBlockWrapper></CenteredFlex4XS>;
    $[12] = t3;
    $[13] = t5;
    $[14] = t7;
    $[15] = withDivider;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
};
export const MoonOneLogo = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <MoonOneLogoWrapper><Logo width="102px" height="36px" /></MoonOneLogoWrapper>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};